module.exports = __webpack_public_path__ + "img/8-sdg-full@2x.c46aea61.png";